import { FEATURE_HERO_TEXT_BOX_BACKGROUND } from "~/hec/components/organisms/feature-hero/feature-hero";
import { HEADING_FONT_OPTIONS } from "~/hec/utils/heading-font";

import { featureLinkInputs } from "../feature-link/inputs";

const IMAGE_TYPES = ["jpeg", "png", "svg", "webp", "gif"];
const ALIGN = ["left", "center", "right"];

/**
 * Builder inputs for Feature Hero — the "Hero" symbol's inputs, the CTA link
 * for the whole hero, and the COM-945 additions (eyebrow, alignment, text box
 * color, heading tag / rich text / font). Height is set in the Style tab.
 */
export const featureHeroInputs = [
  {
    name: "desktopImage",
    friendlyName: "Desktop background image",
    type: "file",
    allowedFileTypes: IMAGE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F1e07bd57fd054601b600816e06494849%2Ffa164987c3ad42efb0024a1e4a7516b2",
    helperText: "Also used on tablet. Decorative: no alt text.",
  },
  {
    name: "mobileImage",
    friendlyName: "Mobile background image",
    type: "file",
    allowedFileTypes: IMAGE_TYPES,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F1e07bd57fd054601b600816e06494849%2F477c2c13fa4148a8bdcd56a3a9f8cfef",
  },
  {
    name: "eyebrow",
    friendlyName: "Eyebrow",
    type: "text",
    helperText: "Small text above the logo. Leave blank for none.",
  },
  {
    name: "logo",
    friendlyName: "Brand logo",
    type: "file",
    allowedFileTypes: IMAGE_TYPES,
    helperText: "Leave blank if no logo is needed.",
  },
  {
    name: "logoAlt",
    friendlyName: "Logo alt text",
    type: "text",
    required: true,
    showIf: "options.get('logo')",
    helperText: "Type what the logo says.",
  },
  {
    name: "heading",
    friendlyName: "Heading",
    type: "richText",
    defaultValue: "<p>Heading</p>",
    helperText: "Leave blank for none.",
  },
  {
    name: "headingTag",
    friendlyName: "Heading tag",
    type: "text",
    enum: ["h1", "h2", "h3"],
    defaultValue: "h2",
    helperText: "Use h1 only when this is the page's main heading.",
  },
  {
    name: "headingFont",
    friendlyName: "Heading font",
    type: "text",
    enum: Object.keys(HEADING_FONT_OPTIONS),
    defaultValue: "Site default",
    helperText:
      "Site default: Volkolak Serif on HSA, Volkolak Sans Serif on FSA.",
  },
  {
    name: "subheading",
    friendlyName: "Subheading",
    type: "longText",
    defaultValue: "sub heading copy",
    helperText: "Leave blank for none.",
  },
  {
    name: "buttonText",
    friendlyName: "Button CTA",
    type: "text",
    defaultValue: "Learn More",
    helperText:
      "The whole hero is the link; the button is only visual. Leave blank for none.",
  },
  {
    name: "badge",
    friendlyName: "Badge",
    type: "file",
    allowedFileTypes: IMAGE_TYPES,
    helperText: "Leave blank if no badge.",
  },
  {
    name: "badgeAlt",
    friendlyName: "Badge alt text",
    type: "text",
    required: true,
    showIf: "options.get('badge')",
  },
  {
    name: "textBoxAlign",
    friendlyName: "Text box position",
    type: "text",
    enum: ALIGN,
    defaultValue: "left",
    helperText: "Tablet and desktop. On mobile the box is full width.",
  },
  {
    name: "textAlign",
    friendlyName: "Text alignment",
    type: "text",
    enum: ALIGN,
    defaultValue: "left",
    helperText: "Tablet and desktop. On mobile the text is centered.",
  },
  {
    name: "textBoxBackgroundColor",
    friendlyName: "Text box background color",
    type: "color",
    defaultValue: FEATURE_HERO_TEXT_BOX_BACKGROUND,
  },
  {
    name: "priority",
    friendlyName: "Above the fold",
    type: "boolean",
    defaultValue: true,
    helperText:
      "Load this image first. Turn off when the hero is lower on the page.",
  },
  // The hero's link. No default Custom URL, same as the other two.
  ...featureLinkInputs,
];
